export default __webpack_public_path__ + "static/media/Icon ionic-ios-arrow-down.2f1aea9d.svg";